<p-blockUI [blocked]="blockedDocument">
 <div class="fixed inset-0 flex flex-col items-center justify-center bg-gray-900/50 z-50">
        <p-progressSpinner></p-progressSpinner>
        <span class="text-white text-lg mt-4">Loading elections...</span>
 </div>
</p-blockUI>
<div class="flex flex-col mb-6">
  <div class="flex items-center justify-between">
    <div>
      <h1 class="text-3xl font-bold text-surface-900 dark:text-surface-0">Election Management</h1>
      <span class="text-surface-500">Manage your campaigns, users and access levels</span>
    </div>
    @if (canCreateElection) {<p-button icon="pi pi-plus" label="New Election" [routerLink]="['/election/new']"></p-button>}
  </div>
</div>

<div class="mb-6">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3 items-end">
        <div>
            <label class="block text-surface-500 text-sm font-medium mb-1">Search</label>
            <p-iconfield iconPosition="left" class="w-full">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" [(ngModel)]="name" pInputText placeholder="Election name..." class="w-full"/>
            </p-iconfield>
        </div>
        <div>
            <label class="block text-surface-500 text-sm font-medium mb-1">Status</label>
            <p-select [options]="statusList" [(ngModel)]="status" optionLabel="name" optionValue="code" placeholder="All" [showClear]="true" class="w-full"/>
        </div>
        <div>
            <label class="block text-surface-500 text-sm font-medium mb-1">Result</label>
            <p-select [options]="resultList" [(ngModel)]="result" optionLabel="name" optionValue="code" placeholder="All" [showClear]="true" class="w-full"/>
        </div>        
        <div>
            <label class="block text-surface-500 text-sm font-medium mb-1">Sort By</label>
            <p-select [options]="sortList" [(ngModel)]="sortBy" optionLabel="name" optionValue="code" placeholder="Most Recent" class="w-full"/>
        </div>
        <div>
            <label class="block text-surface-500 text-sm font-medium mb-1">Start Date Range</label>
            <div class="flex gap-2 items-center">
                <p-datepicker placeholder="From" class="flex-1" [(ngModel)]="startDateFrom" [showClear]="true"/>
                <span class="text-surface-400">-</span>
                <p-datepicker placeholder="To" class="flex-1" [(ngModel)]="startDateTo" [showClear]="true"/>
            </div>
        </div>
    </div>
</div>

@if(filteredItems && filteredItems.length > 0) {
<div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
    <div *ngFor="let campaign of filteredItems">
        <app-election-card [election]="campaign"></app-election-card>
    </div>
</div>
} @else {
<div class="flex flex-col items-center justify-center py-16 text-center">
    <i class="pi pi-inbox text-5xl text-surface-400 mb-4"></i>
    <p class="text-xl text-surface-500 mb-2">No elections found</p>
    <p class="text-sm text-surface-400 mb-6">@if (canCreateElection) {Create your first election to get started} @else {Ask an administrator to add you to an election}</p>
    @if (canCreateElection) {<p-button icon="pi pi-plus" label="New Election" [routerLink]="['/election/new']"></p-button>}
</div>
}
